module.exports = __webpack_public_path__ + "static/media/34.f0ab251e.jpg";